import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';

import {MandantenverwaltungTypspezifikationPage} from './mandantenverwaltung-typspezifikation.page';
import {StoreModule} from '@ngrx/store';
import {reducers} from './mandantenverwaltung-typspezifikation.reducer';
import {EffectsModule} from '@ngrx/effects';
import {MandantenverwaltungTypspezifikationPageUiEffects} from './mandantenverwaltung-typspezifikation.effects.ui';
import {NotificationService} from '@orga-app/providers/notification.service';
import {MandantenverwaltungTypspezifikationPageRoutingModule} from './mandantenverwaltung-typspezifikation-routing.module';
import {MandantenverwaltungTypspezifikationEffectsWs} from './mandantenverwaltung-typspezifikation.effects.ws';
import {ClipboardModule} from 'ngx-clipboard';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {ApiMandantConfigEffects, ApiMandantConfigSpeichernEffects} from '../../../client-ngrx/api';
import {SopiScrollModule} from '../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {SopiDirectivesModule} from '../../../sopi/directives/sopi-directives.module';
import {SopiComponentsModule} from '../../shared/sopi-components/sopi-components.module';
import {PipesModule} from '../../../sopi/pipes/pipes.module';
import {
    VeranstaltungstypenVeranstaltungsTypAdminRolleEntfernenEffects,
    VeranstaltungstypenVeranstaltungsTypAdminRollenEffects, VeranstaltungstypenVeranstaltungsTypAdminRollenHinzufuegenEffects,
    VeranstaltungstypenVeranstaltungsTypAktualisierenEffects,
    VeranstaltungstypenVeranstaltungsTypAnlegenEffects, VeranstaltungstypenVeranstaltungsTypDetailEffects,
    VeranstaltungstypenVeranstaltungsTypenEffects, VeranstaltungstypenVeranstaltungsTypEntfernenEffects,
    VeranstaltungstypenVeranstaltungsTypFeldAktualisierenEffects,
    VeranstaltungstypenVeranstaltungsTypFeldAnlegenEffects,
    VeranstaltungstypenVeranstaltungsTypFelderEffects,
    VeranstaltungstypenVeranstaltungsTypFelderSortierenEffects
} from '../../../client-ngrx/veranstaltungstypen';

@NgModule({
    declarations: [
        MandantenverwaltungTypspezifikationPage,
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ClipboardModule,
        MandantenverwaltungTypspezifikationPageRoutingModule,

        StoreModule.forFeature('MandantenverwaltungTypspezifikationPage', reducers),

        EffectsModule.forFeature([
            MandantenverwaltungTypspezifikationPageUiEffects,
            MandantenverwaltungTypspezifikationEffectsWs,
            ApiMandantConfigEffects,
            ApiMandantConfigSpeichernEffects,

            VeranstaltungstypenVeranstaltungsTypenEffects,
            VeranstaltungstypenVeranstaltungsTypDetailEffects,
            VeranstaltungstypenVeranstaltungsTypAnlegenEffects,
            VeranstaltungstypenVeranstaltungsTypEntfernenEffects,
            VeranstaltungstypenVeranstaltungsTypAktualisierenEffects,
            VeranstaltungstypenVeranstaltungsTypAdminRollenEffects,
            VeranstaltungstypenVeranstaltungsTypAdminRollenHinzufuegenEffects,
            VeranstaltungstypenVeranstaltungsTypAdminRolleEntfernenEffects,
            VeranstaltungstypenVeranstaltungsTypFelderEffects,
            VeranstaltungstypenVeranstaltungsTypFeldAnlegenEffects,
            VeranstaltungstypenVeranstaltungsTypFeldAktualisierenEffects,
            VeranstaltungstypenVeranstaltungsTypFelderSortierenEffects
        ]),
        ReactiveFormsModule,
        SopiScrollModule,
        SopiDirectivesModule,
        DragDropModule,
        SopiComponentsModule.forRoot(),
        PipesModule
    ],
    providers: [
        NotificationService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class MandantenverwaltungTypspezifikationPageModule {

}
